import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { OnlyNativeGuard } from './guards/only-native.guard';
import { OnlyRegularVersionGuard } from './guards/only-regular-version.guard';
import { OnlyUnverifiedGuard } from './guards/only-unverified.guard';
import { OnlyVerifiedGuard } from './guards/only-verified.guard';
import { OnlyWebGuard } from './guards/only-web.guard';
import { PermissionsGuard } from './guards/permissions.guard';
import { MenuColorScheme } from './interfaces/menu-color-scheme.interface';
import { ShowComponent } from './pages/shared/show/show.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'activation',
    pathMatch: 'full',
  },
  {
    path: 'authorization',
    loadChildren: () =>
      import('./pages/authorization/authorization.module').then(
        (m) => m.AuthorizationPageModule
      ),
    canActivate: [OnlyUnverifiedGuard, OnlyWebGuard],
    canLoad: [OnlyUnverifiedGuard, OnlyWebGuard],
  },
  {
    path: 'activation',
    loadChildren: () =>
      import('./pages/activation/activation.module').then(
        (m) => m.ActivationPageModule
      ),
    canActivate: [OnlyUnverifiedGuard, OnlyNativeGuard],
    canLoad: [OnlyUnverifiedGuard, OnlyNativeGuard],
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./pages/auth/auth.module').then((m) => m.AuthPageModule),
    canActivate: [OnlyVerifiedGuard, OnlyNativeGuard],
    canLoad: [OnlyVerifiedGuard, OnlyNativeGuard],
  },
  {
    path: 'show',
    component: ShowComponent,
    children: [
      {
        path: 'dashboard',
        data: { title: 'dashboard.title' },
        loadChildren: () =>
          import('./pages/dashboard/dashboard.module').then(
            (m) => m.DashboardPageModule
          ),
      },
      {
        path: 'contracts',

        data: { permission: 'umowy', title: 'contracts.title' },
        loadChildren: () =>
          import('./pages/contracts/contracts.module').then(
            (m) => m.ContractsPageModule
          ),
        canActivate: [PermissionsGuard],
      },
      {
        path: 'invoices',

        data: { permission: 'faktury', title: 'invoices.title' },
        loadChildren: () =>
          import('./pages/invoices/invoices.module').then(
            (m) => m.InvoicesPageModule
          ),
        canActivate: [PermissionsGuard],
      },
      {
        path: 'pickups',
        data: { title: 'pickups.title' },
        loadChildren: () =>
          import('./pages/pickups/pickups.module').then(
            (m) => m.PickupsPageModule
          ),
      },
      {
        path: 'kpo',

        data: { permission: 'kpo', title: 'kpo.title' },
        loadChildren: () =>
          import('./pages/kpo/kpo.module').then((m) => m.KPOPageModule),
        canActivate: [PermissionsGuard],
      },
      {
        path: 'contacts',
        data: { title: 'contacts.title' },
        loadChildren: () =>
          import('./pages/contacts/contacts.module').then(
            (m) => m.ContactsPageModule
          ),
        canActivate: [OnlyRegularVersionGuard],
        canLoad: [OnlyRegularVersionGuard],
      },
      {
        path: 'settings',
        data: { title: 'settings.title' },
        loadChildren: () =>
          import('./pages/settings/settings.module').then(
            (m) => m.SettingsPageModule
          ),
      },
      {
        path: 'news',
        data: { title: 'news.title' },
        loadChildren: () =>
          import('./pages/news/news.module').then((m) => m.NewsPageModule),
        canActivate: [OnlyRegularVersionGuard],
        canLoad: [OnlyRegularVersionGuard],
      },
      {
        path: 'under-construction',
        data: { title: 'under-construction.title' },
        loadChildren: () =>
          import('./pages/under-construction/under-construction.module').then(
            (m) => m.UnderConstructionPageModule
          ),
      },
      {
        path: 'notifications',
        data: { title: 'notifications.title' },
        loadChildren: () =>
          import('./pages/notifications/notifications.module').then(
            (m) => m.NotificationsPagePageModule
          ),
      },
      {
        path: 'blocked-feature',
        data: { title: 'blockedFeature.title' },
        loadChildren: () =>
          import('./pages/blocked-feature/blocked-feature.module').then(
            (m) => m.BlockedFeaturePageModule
          ),
      },
      {
        path: 'additional-services',
        data: { title: 'additionalServices.title' },
        loadChildren: () =>
          import('./pages/additional-services/additional-services.module').then(
            (m) => m.AdditionalServicesPageModule
          ),
        canActivate: [OnlyRegularVersionGuard],
        canLoad: [OnlyRegularVersionGuard],
      },
      {
        path: 'adr',
        data: { title: 'adr.title', colorScheme: MenuColorScheme.ORANGE },
        loadChildren: () =>
          import('./pages/adr/adr.module').then((m) => m.AdrPageModule),
        canActivate: [OnlyRegularVersionGuard],
        canLoad: [OnlyRegularVersionGuard],
      },
      {
        path: 'adr-promotion',
        data: {
          title: 'adrPromotion.title',
          colorScheme: MenuColorScheme.ORANGE,
        },
        loadChildren: () =>
          import('./pages/adr-promotion/adr-promotion.module').then(
            (m) => m.AdrPromotionPageModule
          ),
        canActivate: [OnlyRegularVersionGuard],
        canLoad: [OnlyRegularVersionGuard],
      },
    ],
    canActivate: [OnlyVerifiedGuard],
    canLoad: [OnlyVerifiedGuard],
  },
  {
    path: '**',
    redirectTo: 'activation',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
